export default __webpack_public_path__ + "static/afiU-logo-horizontal-fr-f39c5dbf70ad878e7824d0a093dd3d00.svg";